/**
 * Endpoint methods related to Certificates
*/

import API from "./Api";

export default {
  /**
   * Gets all the Certificates related to the logged-In Instance
   */
  async getAllOwnCertificates() {
    return API.get("/certificates/getallown", "COOKIE_TOKEN_SESSION");
  },
};
